export var ColumnSortOrder;
(function (ColumnSortOrder) {
    ColumnSortOrder["Ascending"] = "asc";
    ColumnSortOrder["Descending"] = "desc";
})(ColumnSortOrder || (ColumnSortOrder = {}));
